import axios from "axios";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL;

export const API =
  `${BACKEND_URL}/api`;

export const api =
  axios.create({
    baseURL: API,
  });

const EMPLOYER_READY_TALENT_STAGE =
  "stage_six_recorded_interview";

const EMPLOYER_READY_ADMIN_STATUSES =
  new Set([
    "approved",
    "active",
    "shortlist_ready",
  ]);

function normalise(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

function isEmployerReadyTalentCandidate(
  candidate
) {
  if (
    !candidate ||
    typeof candidate !== "object"
  ) {
    return false;
  }

  return (
    normalise(
      candidate.talent_pool_stage
    ) ===
      EMPLOYER_READY_TALENT_STAGE &&
    EMPLOYER_READY_ADMIN_STATUSES.has(
      normalise(
        candidate.talent_pool_admin_status
      )
    )
  );
}

function getCurrentTokenRole() {
  const token =
    localStorage.getItem(
      "rc_token"
    );

  if (!token) {
    return null;
  }

  try {
    const payloadPart =
      token.split(".")[1];

    if (!payloadPart) {
      return null;
    }

    const normalised =
      payloadPart
        .replace(/-/g, "+")
        .replace(/_/g, "/");

    const padded =
      normalised.padEnd(
        normalised.length +
          ((4 -
            (normalised.length %
              4)) %
            4),
        "="
      );

    const payload =
      JSON.parse(
        window.atob(padded)
      );

    return normalise(
      payload?.role
    );
  } catch {
    return null;
  }
}

function employerTalentVisibilityFilter(
  response
) {
  if (
    getCurrentTokenRole() !==
    "employer"
  ) {
    return response;
  }

  const url =
    String(
      response.config?.url ||
        ""
    ).split("?")[0];

  if (
    url.startsWith(
      "/employer/talent-pool/members"
    ) &&
    Array.isArray(
      response.data
    )
  ) {
    response.data =
      response.data.filter(
        isEmployerReadyTalentCandidate
      );

    return response;
  }

  if (
    url ===
      "/talent-pool/candidates" &&
    Array.isArray(
      response.data
    )
  ) {
    response.data =
      response.data.filter(
        isEmployerReadyTalentCandidate
      );

    return response;
  }

  if (
    url ===
      "/talent-pool/candidates/one-pager" &&
    Array.isArray(
      response.data
    )
  ) {
    response.data =
      response.data.filter(
        (row) =>
          isEmployerReadyTalentCandidate(
            row?.candidate
          )
      );
  }

  return response;
}

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem(
        "rc_token"
      );

    if (token) {
      config.headers.Authorization =
        `Bearer ${token}`;
    }

    return config;
  }
);

/*
 * Employer Talent Pool visibility is intentionally conservative while the
 * full Stage 1–6 workflow is being completed. Employers only see candidates
 * who are at Stage 6 and have a positive Railway Careers admin status.
 *
 * Admin users are not filtered and retain the full management view.
 */
api.interceptors.response.use(
  employerTalentVisibilityFilter
);

export const setToken = (t) => {
  if (t) {
    localStorage.setItem(
      "rc_token",
      t
    );
  } else {
    localStorage.removeItem(
      "rc_token"
    );
  }
};

export const getToken = () =>
  localStorage.getItem(
    "rc_token"
  );